import { lightBlue } from '@mui/material/colors'
import { styled } from '@mui/material/styles'
import { DataGridPremium } from '@mui/x-data-grid-premium'
import { getBackgroundColor } from './utils'

export enum DataGridCSSClasses {
  Error = 'datagrid-theme-Error',
  Warning = 'datagrid-theme-Warning',
  Success = 'datagrid-theme-Success',
  Highlight = 'datagrid-theme-Highlight',
}

const StyledDataGrid = styled(DataGridPremium)(({ theme }) => ({
  '& .MuiDataGrid-cell.Mui-selected': {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .MuiDataGrid-cell': {
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },
  },
  [`& .${DataGridCSSClasses.Error}`]: {
    ...getBackgroundColor(theme.palette.error.main, theme, 0.7),
    '&:hover': {
      ...getBackgroundColor(theme.palette.error.main, theme, 0.6),
    },
    '&.Mui-selected': {
      ...getBackgroundColor(theme.palette.error.main, theme, 0.5),
      '&:hover': {
        ...getBackgroundColor(theme.palette.error.main, theme, 0.4),
      },
    },
  },
  [`& .${DataGridCSSClasses.Warning}`]: {
    ...getBackgroundColor(theme.palette.warning.main, theme, 0.7),
    '&:hover': {
      ...getBackgroundColor(theme.palette.warning.main, theme, 0.6),
    },
    '&.Mui-selected': {
      ...getBackgroundColor(theme.palette.warning.main, theme, 0.5),
      '&:hover': {
        ...getBackgroundColor(theme.palette.warning.main, theme, 0.4),
      },
    },
  },
  [`& .${DataGridCSSClasses.Success}`]: {
    ...getBackgroundColor(theme.palette.success.main, theme, 0.7),
    '&:hover': {
      ...getBackgroundColor(theme.palette.success.main, theme, 0.6),
    },
    '&.Mui-selected': {
      ...getBackgroundColor(theme.palette.success.main, theme, 0.5),
      '&:hover': {
        ...getBackgroundColor(theme.palette.success.main, theme, 0.4),
      },
    },
  },
  [`& .${DataGridCSSClasses.Highlight}`]: {
    ...getBackgroundColor(lightBlue[200], theme, 0.7),
    '&:hover': {
      ...getBackgroundColor(lightBlue[200], theme, 0.6),
    },
    '&.Mui-selected': {
      ...getBackgroundColor(lightBlue[200], theme, 0.5),
      '&:hover': {
        ...getBackgroundColor(lightBlue[200], theme, 0.4),
      },
    },
  },
}))

export default StyledDataGrid
